<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      黄阁坑站<br>
站点介绍<br>
黄阁坑站位于龙岗区黄阁路与清林路交叉口处，车站主体沿黄阁路呈南北走向布置，南接龙城公园站，北接愉园站。车站色彩基调以蓝色调为主，以"数码科技概念"为主题，营造时尚科技的空间。车站为地下一层结构，地下一层为站厅和站台层，站台形式为侧式站台。车站设置有5个出入口，临近深圳广播电视大学（龙岗分校）、深圳市龙岗职业技术学校，周边以住宅区和写字楼为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:07	23:06	16号线	5分32秒	6分35秒<br>
田心	06:00	23:42	16号线	5分32秒	6分35秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:07	23:06	16号线	5分50秒	6分钟-9分钟<br>
田心	06:02	23:42	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:07	00:06	16号线	5分50秒	6分钟-9分钟<br>
田心	06:02	00:42	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
清林路南侧、深圳市龙岗中等专业学校/深圳市龙岗职业技术学校、龙岗区教育局、深圳广播电视大学（龙岗分校）、深圳市龙岗区教师进修学校<br><br>
A2出入口:<br>
黄阁路东侧（南）<br><br>
B出入口:<br>
黄阁路东侧（北）、天健现代城<br><br>
C出入口:<br>
黄阁路西侧（北）、天安数码城<br><br>
D出入口:<br>
黄阁路西侧（南）、广东省技师学院（深圳校区）、大围工业区<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 龙岗党校<br>
E27、M139、M165、M220、M229、M280、M593、810、818、833、862、E5、E25、M447、M569、高峰专线185、高快巴士81<br><br>
A2出入口:<br>
公交站名： 龙岗中专<br>
810、818、833、862、E5、E27、M447、M569、高快巴士81、M139、M220、M229、M317、M360、M593<br><br>
B出入口:<br>
公交站名： 龙岗天安数码城①<br>
M317、M360、M386、M446、高峰专线146、高峰专线185C出入口<br><br>
D出入口:<br>
公交站名： 龙岗中专<br>
M139、M220、M229、M317、M360、M446、M593<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>